import { SecondSubTitleParagraph } from "styles/jss/Layout.styles";

export default function SecondSubTitle({ children, classname }) {
  return (
    <SecondSubTitleParagraph className={classname}>
      {children}
    </SecondSubTitleParagraph>
  );
}
